export class EventEmitter {
    constructor() {
        this.listeners = new Map();
    }
    async emit(eventName, ...args) {
        const listeners = this.listeners.get(eventName);
        const ret = new Array();
        if (listeners !== undefined) {
            for (let i = 0; i < listeners.length; i++) {
                const listener = listeners[i];
                ret.push(await listener(...args));
            }
        }
        return ret;
    }
    addListener(eventName, listener) {
        if (!this.listeners.has(eventName))
            this.listeners.set(eventName, []);
        const listeners = this.listeners.get(eventName);
        listeners.push(listener);
    }
    removeListener(eventName, listener) {
        const listeners = this.listeners.get(eventName);
        const index = listeners.lastIndexOf(listener);
        listeners.splice(index, 1);
        if (listeners.length === 0)
            this.listeners.delete(eventName);
    }
}
